import { render, staticRenderFns } from "./AddSectorModal.vue?vue&type=template&id=2f6104ea&lang=pug&"
import script from "./AddSectorModal.vue?vue&type=script&lang=js&"
export * from "./AddSectorModal.vue?vue&type=script&lang=js&"
import style0 from "./AddSectorModal.vue?vue&type=style&index=0&id=2f6104ea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports